/**
 * Platform presets — Phase 25-AB Task 12.
 *
 * Source-of-truth: docs/mockups/export.html lines 558-571 (panel 21-B).
 * 8 platforms with aspect / resolution / duration caps + recommended format.
 *
 * Selecting a platform should auto-apply aspect ratio + length cap in the
 * editor; the host can also auto-toggle the recommended format key in the
 * format grid.
 */

export type AspectRatio = "9:16" | "16:9" | "1:1";

export interface PlatformPreset {
	key: string;
	name: string;
	aspect: AspectRatio;
	resolution: { w: number; h: number };
	maxDuration: number; // seconds
	recommendedFormat: string;
	iconId: string; // SVG symbol id (e.g. "i-platform-yt")
	dev: string;
}

export const PLATFORMS: readonly PlatformPreset[] = [
	{
		key: "youtube-shorts",
		name: "YouTube",
		aspect: "9:16",
		resolution: { w: 1080, h: 1920 },
		maxDuration: 60,
		recommendedFormat: "mp4-1080p",
		iconId: "i-platform-yt",
		dev: "21-B1",
	},
	{
		key: "tiktok",
		name: "TikTok",
		aspect: "9:16",
		resolution: { w: 1080, h: 1920 },
		maxDuration: 180,
		recommendedFormat: "mp4-1080p",
		iconId: "i-platform-tt",
		dev: "21-B2",
	},
	{
		key: "instagram-reels",
		name: "Instagram",
		aspect: "9:16",
		resolution: { w: 1080, h: 1920 },
		maxDuration: 90,
		recommendedFormat: "mp4-1080p",
		iconId: "i-platform-ig",
		dev: "21-B3",
	},
	{
		key: "threads",
		name: "Threads",
		aspect: "9:16",
		resolution: { w: 1080, h: 1920 },
		maxDuration: 300,
		recommendedFormat: "mp4-1080p",
		iconId: "i-platform-th",
		dev: "21-B4",
	},
	{
		key: "facebook-reels",
		name: "Facebook",
		aspect: "9:16",
		resolution: { w: 1080, h: 1920 },
		maxDuration: 60,
		recommendedFormat: "mp4-1080p",
		iconId: "i-platform-fb",
		dev: "21-B5",
	},
	{
		key: "twitter",
		name: "X · Twitter",
		aspect: "16:9",
		resolution: { w: 1280, h: 720 },
		maxDuration: 140,
		recommendedFormat: "mp4-720p",
		iconId: "i-platform-x",
		dev: "21-B6",
	},
	{
		key: "linkedin",
		name: "LinkedIn",
		aspect: "16:9",
		resolution: { w: 1920, h: 1080 },
		maxDuration: 600,
		recommendedFormat: "mp4-1080p",
		iconId: "i-platform-li",
		dev: "21-B7",
	},
	{
		key: "pinterest",
		name: "Pinterest",
		aspect: "9:16",
		resolution: { w: 720, h: 1280 },
		maxDuration: 60,
		recommendedFormat: "mp4-720p",
		iconId: "i-platform-pin",
		dev: "21-B8",
	},
] as const;

export const PLATFORM_COUNT = PLATFORMS.length;
